import ServiceCalibMap from 'pages/Robot/RobotView/RobotLeftBlock/Service/ServiceCalibMap'
import type { ApiStationRow } from 'pages/Robot/RobotView/RobotLeftBlock/Service/serviceCalibApi'
import { useMemo } from 'react'
import { IMaintenancePoint } from 'utils/interfaces'
import {
  catalogKeyForServicePoint,
  FacilityLotRow,
  scenarioServicePointsToCatalogItems,
} from 'utils/scenarioServicePointMap'
import { IServicePoint } from 'utils/servicePointsCatalog'

const ScenarioServicePointsOnMap = ({
  map,
  servicePoints,
  facilityLots,
  maintenancePoints,
  stations,
  highlightedSpIndex,
  onSelectSpIndex,
  interactive = true,
}: {
  map: mapboxgl.Map | undefined
  servicePoints: IServicePoint[]
  facilityLots: FacilityLotRow[]
  maintenancePoints: IMaintenancePoint[]
  stations: ApiStationRow[]
  highlightedSpIndex?: number | null
  onSelectSpIndex?: (index: number | undefined) => void
  interactive?: boolean
}) => {
  const items = useMemo(
    () => scenarioServicePointsToCatalogItems(servicePoints, facilityLots, maintenancePoints, stations),
    [servicePoints, facilityLots, maintenancePoints, stations]
  )

  const selectedKey = useMemo(() => {
    if (highlightedSpIndex == null || highlightedSpIndex < 0) {
      return null
    }
    const sp = servicePoints[highlightedSpIndex]
    if (!sp) {
      return null
    }
    return catalogKeyForServicePoint(sp, facilityLots, maintenancePoints)
  }, [highlightedSpIndex, servicePoints, facilityLots, maintenancePoints])

  const keyToSpIndex = useMemo(() => {
    const mapKeys = new Map<string, number>()
    servicePoints.forEach((sp, index) => {
      const key = catalogKeyForServicePoint(sp, facilityLots, maintenancePoints)
      if (key && !mapKeys.has(key)) {
        mapKeys.set(key, index)
      }
    })
    return mapKeys
  }, [servicePoints, facilityLots, maintenancePoints])

  if (items.length === 0) {
    return null
  }

  return (
    <ServiceCalibMap
      map={map}
      items={items}
      selectedKey={selectedKey}
      onSelectKey={
        interactive
          ? key => {
              if (!key) {
                onSelectSpIndex?.(undefined)
                return
              }
              onSelectSpIndex?.(keyToSpIndex.get(key))
            }
          : () => {}
      }
    />
  )
}

export default ScenarioServicePointsOnMap
